import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import ActivationTxnHistoryTable from "./table/activationTxnHistoryTable";

const ActivationTxnHistoryPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="activationtxnhistory_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Activatio Wallet History"
      countContainer="My mono Balance : 248.00 mono"
      table={<ActivationTxnHistoryTable />}
      calculateContainer={true}
      calculateCredit="Total Credit : 0.00"
      calculateDebit="Total Debit : 0.00"
    />
  );
};

export default ActivationTxnHistoryPage;
